import { render, staticRenderFns } from "./JapaneseFile.vue?vue&type=template&id=3cfb6e22&"
import script from "./JapaneseFile.vue?vue&type=script&lang=js&"
export * from "./JapaneseFile.vue?vue&type=script&lang=js&"
import style0 from "./JapaneseFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports